import React from "react";
import { useSelector } from "react-redux";
import WidgetCarouselCard from "../../features/widget/widgetCarouselCard/WidgetCarouselCard";
import pathRouts from "../../../enums/pathRoute";
import discoveryWidgetImg from "../../../../assests/discovery/discoveryWidget.png";

const DiscoveryCarouselWidget = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <WidgetCarouselCard
            color="#C3D48B"
            title={texts.ContentLibrary}
            image={discoveryWidgetImg}
            imageAlt={texts.discovery}
            link={`/${pathRouts.DISCOVERY}`}
        />
    );
};

export default DiscoveryCarouselWidget;
